import formatDuration from '../../../../helpers/date-time/format-duration'
import { renderCalcPos, onAnyStandardCell } from '../../helpers/helpers'
import type { CalculationColumn } from '../../types/column-types'

export const calculatedTimeColumns: CalculationColumn[] = [
    {
        dataIndex: ['calculated', 'time'],
        title: 'Время',
        // @ts-ignore
        children: [
            {
                dataIndex: ['calculated', 'printingTime'],
                title: 'Время на тираж',
                width: 80,
                onCell: onAnyStandardCell,
                render: renderCalcPos(r => formatDuration(r.calculated?.printingTime || 0)),
            },
            {
                dataIndex: ['calculated', 'finishingTime'],
                title: 'Время на отделку',
                width: 80,
                onCell: onAnyStandardCell,
                render: renderCalcPos(r => formatDuration(r.calculated?.finishingTime || 0)),
            },
            {
                dataIndex: ['calculated', 'commonTime'],
                title: 'Общее время',
                width: 80,
                onCell: onAnyStandardCell,
                render: renderCalcPos(r => formatDuration(r.calculated?.commonTime || 0)),
            },
        ],
    },
]
